import { useMemo } from 'react';
import { getBranding } from '../config/brandingConfig';

/**
 * Returns branding config for the current domain.
 * Memoized -- only recalculates if hostname changes (which it won't during session).
 */
const useBranding = () => {
  return useMemo(() => getBranding(window.location.hostname), []);
};

export default useBranding;
